import React from 'react';
import { Route, Link } from "react-router-dom";
import redirect from '../components/redirect/redirect';
import customRequest from '../helpers/customRequest';
import message from '../components/message/message';

import { Phonics, Phrases, Stories } from '@stem-sims/great-leaps-react-common'

class Probes extends React.Component
{
    /*********************
    * Global Variables
    *********************/
    state =
    {
        //returned from API Request
        title: "",
        responses: [],
        sectionClass : null,
        groupLength  : null,
        indentedParagraphs : null,
    }
    

    /****************
    * React Functions
    *****************/

    componentDidMount()
    {
        const { probeNumber } = this.props.match.params
        const { type } = this.props

        if (isNaN(probeNumber))
        {
            //ABORT ABORT
            redirect.send('/student/dashboard', () => {
                message.error('Please select excercise again.')
            })
        }

        
        customRequest.get('/api/probe', {
            params: {
                type: type,
                number: parseInt(probeNumber)
            }
        })
        .then(({data}) =>
        {
            if (data.valid === false) {
                return redirect.send("/student/dashboard", () => {
                    message.error(data.message)
                })
            }
            this.setState(data)
        })
        .catch((error) => {
            return redirect.send("/student/dashboard", () => {
                message.error(error)
            })
        })
    }

    render()
    {
        const { title, responses, groupLength, sectionClass, indentedParagraphs } = this.state
        const { probeNumber } = this.props.match.params

        var commonRouteProps = {
            exerciseNumber : probeNumber,
            title : title,
            responses : responses,
            hideGhosting: true
        }

        return (
            <React.Fragment>

                <Route exact path="/student/probes/phonics/:probeNumber">
                    <Phonics {...commonRouteProps} sectionClass = {sectionClass} groupLength = {groupLength}/>
                </Route>

                <Route exact path="/student/probes/phrases/:probeNumber">
                    <Phrases {...commonRouteProps} sectionClass = {sectionClass} />
                </Route>
                {
                ["high", "middle", "elementary"].map((type) => {
                    return (
                    <Route exact path={`/student/probes/${type}/:probeNumber`}>
                        <Stories {...commonRouteProps} indentedParagraphs={indentedParagraphs}/>
                    </Route>)
                })
                }
            <div class = "row">
                <div class = "col-6 offset-3 col-sm-4 offset-sm-4">
                    <Link to = "/student/dashboard" class = "btn btn-secondary btn-lg">
                        <svg class = "button-arrow" width = "2.68em" height = "1.25em" viewBox = "-25 -5 50 30">
                            <g transform = "scale(<?php echo $xScale; ?>, 1)">
                                <path d = "M-5,0L-20,10L-5,20" class = "line"></path>
                                
                                <path d = "M-20,10L20,10" class = "line"></path>
                            </g>
                        </svg>
                        Back<span class = "d-none d-sm-inline hidden-sm"> to Exercise List</span>
                    </Link>
                </div>
            </div>
        </React.Fragment>
        
        )
    }
}

export default Probes
